<template>
  <div>
    <el-dialog :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :append-to-body="true"
               custom-class="window"
               width="60%"
               top="5vh"
               :show-close="false"
               :title="title">
      <el-steps :active="showStep"
                style="margin-bottom: 20px;"
                simple>
        <el-step :title="`1. ` + $t('diagramDialog.SelectPlan')"></el-step>
        <el-step :title="`2. ` + $t('diagramDialog.SelectLayers')"></el-step>
      </el-steps>
      <div class="step-1"
           v-show="showStep === 1">
        <el-row style="margin-bottom:10px">
          <el-col :span="24">
            <el-input :placeholder="$t('diagramDialog.SearchforPlans')"
                      size="mini"
                      @change="search()"
                      @clear="search()"
                      clearable
                      v-model="projectCondition.Value"></el-input>
          </el-col>
        </el-row>
        <el-table :data="projectList"
                  v-loading="loading"
                  size="small"
                  @row-click="nextStep">
          <el-table-column :label="$t('diagramDialog.Name')">
            <template slot-scope="scope">
              {{scope.row.Name}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('diagramDialog.Owner')"
                           width="200">
            <template slot-scope="scope">
              {{scope.row.CreatorAccount}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('diagramDialog.LastUpdated')"
                           width="150">
            <template slot-scope="scope">
              {{scope.row.LastUpdatedOn.substring(0,10)}}
            </template>
          </el-table-column>

        </el-table>
        <el-pagination background
                       small
                       style="margin-top:5px;"
                       @current-change="handleCurrentChange"
                       layout="total, prev, pager, next"
                       :current-page="projectCondition.PageIndex"
                       :page-size="projectCondition.PageSize"
                       :total="projectTotal">
        </el-pagination>
      </div>
      <div class="step-2"
           v-show="showStep === 2">
        <div class="layer-box">
          <myScroll style="width:100%;height:100%">
            <el-table :data="layerList"
                      v-loading="loading"
                      ref="tableLayer"
                      @selection-change="handleSelectionChange">
              <el-table-column :label="arraySelectText">
                <template slot-scope="scope">
                  <img :src="scope.row.url"
                       style="width:120px;height:120px"
                       alt="">
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  {{scope.row.Name}}
                </template>
              </el-table-column>
              <el-table-column type="selection"
                               label="Select All"
                               width="55"></el-table-column>
            </el-table>
          </myScroll>
        </div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="closeDialog"
                   size="small">{{$t('diagramDialog.Cancel')}}</el-button>
        <el-button type="primary"
                   @click="lastStep"
                   size="small"
                   v-if="showStep !== 1">{{$t('diagramDialog.Previous')}}</el-button>
        <el-button type="primary"
                   v-if="showStep === 2"
                   @click="save()"
                   :loading="btnLoading"
                   size="small"
                   :disabled="layerCheck.length < 1">{{$t('diagramDialog.Save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getM2Project, getPlansList, getLayerList, addPlans } from '@/api/config'
import { mapState } from 'vuex'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    openFrom: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      btnLoading: false,
      loading: false,
      projectCondition: {
        Value: null,
        PageIndex: 1,
        PageSize: 8,
        OrderBy: 'LastUpdatedOn desc'
      },
      planCondition: {
        PageIndex: 1,
        PageSize: 10000,
        GetRecycle: false,
        AllowLoadTaskCount: false,
        OrderBy: 'LastUpdatedOn desc'
      },
      existPlans: [],
      projectList: [],
      projectTotal: 0,
      layerList: [],
      layerCheck: [],
      title: this.$t('diagramDialog.AddingPlan'),
      showStep: 1
    }
  },
  computed: {
    ...mapState(['jobsiteID']),
    arraySelectText () {
      return this.layerCheck.length > 0 ? this.layerCheck.length + ' ' + this.$t('project.Selected') : this.$t('project.NoneSelected')
    }
  },
  created () {
  },
  mounted () {

  },
  watch: {
    showDialog (to, from) {
      if (to) {
        this.projectCondition.PageIndex = 1
        this.projectCondition.Value = null
        this.layerCheck = []
        this.showStep = 1
        this.getM2Project()
      }
    }
  },
  methods: {
    handleSelectionChange (val) {
      this.layerCheck = val
    },
    search () {
      this.projectCondition.PageIndex = 1
      this.getM2Project()
    },
    handleCurrentChange (val) {
      this.projectCondition.PageIndex = val
      this.getM2Project()
    },
    getM2Project () {
      this.loading = true
      getM2Project(this.projectCondition).then(res => {
        this.projectList = res.Data
        this.projectTotal = res.TotalCount
        this.loading = false
      })
    },
    getLayerList (projectId) {
      return new Promise((resolve, reject) => {
        getLayerList(projectId).then(res => {
          if (!res.Status) {
            resolve(res)
          } else {
            this.loading = false
          }
        })
      })
    },
    getExistPlansList (projectId) {
      this.planCondition.JobsiteId = this.jobsiteID
      this.planCondition.LinkProjectId = projectId
      this.existPlans = []
      getPlansList(this.planCondition).then(res => {
        this.existPlans = res.Data
      })
    },
    async nextStep (row) {
      this.loading = true
      if (row.ProjectId) {
        await this.getExistPlansList(row.ProjectId)
        let list = await this.getLayerList(row.ProjectId)
        this.layerList = []
        list.forEach((res, index) => {
          if (!this.existPlans.find(q => q.LinkProjectId === res.ProjectId && q.LinkLayerShapeId === res.ShapeId)) {
            res.url = this.$config.baseURL + '/api/M2Projects/' + row.ProjectId + '/Layers/' + res.ShapeId + '/Image'
            res.LayerIndex = index
            res.Revision = row.Revision
            this.layerList.push(res)
          }
        })
        console.log(this.layerList)
        this.$refs.tableLayer.toggleAllSelection()
      }
      this.showStep += 1
      this.loading = false
    },
    lastStep () {
      this.showStep -= 1
    },
    closeDialog (needRefresh) {
      this.$emit('closeDialog', needRefresh)
    },
    save () {
      let that = this
      this.btnLoading = true
      this.loading = true
      let params = {
        JobsiteId: this.jobsiteID,
        M2Plans: []
      }
      this.layerCheck.forEach(ele => {
        let obj = {
          ProjectId: ele.ProjectId,
          LayerShapeId: ele.ShapeId,
          LayerName: ele.Name ? ele.Name : 'layer',
          LayerIndex: ele.LayerIndex,
          Revision: ele.ProjectRevision,
          DiagramName: ele.ProjectName
        }
        params.M2Plans.push(obj)
      })
      addPlans(params).then(res => {
        this.btnLoading = false
        this.loading = false
        this.$emit('closeDialog', true)
        if (that.openFrom === 'Project') {
          this.$router.push({
            name: 'diagrams'
          })
        }
      }).catch(err => {
        this.btnLoading = false
        this.loading = false
        this.layerCheck = []
        console.log(err)
      })
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
/deep/.el-step__head {
  display: none;
}
.el-steps {
  margin-bottom: 20px;
}
.step-1 {
  .line {
    text-align: center;
  }
  .el-pagination {
    margin-top: 10px;
    text-align: right;
  }
}
.step-2 {
  .layer-box {
    width: 100%;
    height: 450px;
  }
}
</style>
